import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled.span`
  align-items: center;
  color: var(--primary);
  display: flex;
  font-size: var(--x-large);
  justify-content: center;

  svg {
    height: 1em;
    width: 1em;

    path {
      fill: currentColor;
    }
  }
`;

const Logo = ({ className }) => (
  <Wrapper className={className}>
    <svg viewBox="0 0 1600 2000" xmlns="http://www.w3.org/2000/svg">
      <path d="M695.6 1083.4l555.9 870.5c14.1 21.2 35.3 31 60.7 31h206c39.5 0 70.5-31 70.5-70.5V70.4c0-66.3-83.2-95.9-127-43.7L695.6 998.8c-16.9 22.6-16.9 57.8 0 84.6zM70.6 1985h366.8c39.5 0 70.5-31 70.5-70.5V1446c0-66.3-83.2-95.9-127-43.7L14.1 1870.7c-35.2 48 0 114.3 56.5 114.3z" />
    </svg>
  </Wrapper>
);

Logo.propTypes = {
  className: PropTypes.string,
};

export default styled(Logo)``;
